module.exports = __webpack_public_path__ + "img/chongzhi-top.cb94d22f.png";